import React, { Component } from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import { Tooltip } from 'reactstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faStar } from '@fortawesome/free-solid-svg-icons';
import defaultUserPhoto from '../../../../images/default_user.png';
import { jobWorkerStatuses, jobWorkerStatus, workerBreakMinutesValues, workerSentHomeReasons } from '../../../../constants/jobs';
import { confirmationMessages, alertMessages, otherSentHomeReason } from '../../../../constants/text';
import { uiDateFormat } from '../../../../constants/date';
import { formatCheckInDate, formatPrice } from '../../../../helpers/formatData';
import { getDollarPrice } from '../../../../helpers/general';
import { isWorkerHired, isWorkerOffered } from '../../../../helpers/jobs';
import UsersService from '../../../../services/UsersService';
import HoursPopup from './HoursPopup';
import MapsPopup from './MapsPopup';
import { getDateWithOffset, renderDateWithTimeZone } from '../../../../helpers/timezones';
import JobWorkerTimeline from '../../jobsList/JobInfoWorker/JobWorkerTimeline';
import WorkerActionsMenu from './WorkerActionsMenu';

export default class Worker extends Component {
  static propTypes = {
    worker: PropTypes.object.isRequired,
    jobStartDate: PropTypes.object.isRequired,
    jobEndDate: PropTypes.object.isRequired,
    time_zone_id: PropTypes.string.isRequired,
    jobId: PropTypes.number,
    editJobWorker: PropTypes.func.isRequired,
    jobIsNotEditable: PropTypes.bool.isRequired,
    jobHasNotStarted: PropTypes.bool.isRequired,
    jobStatusIsFilled: PropTypes.bool.isRequired,
    UIShowConfirm: PropTypes.func.isRequired,
    UIShowAlert: PropTypes.func.isRequired,
    onQuickViewOpen: PropTypes.func.isRequired,
  };

  state = {
    statusTooltipIsShown: false
  };

  getCoords = (geopoints) => {
    if (geopoints) {
      const re = /\(([^)]+)\)/;
      const point = re.exec(geopoints)[1];
      const geo = point.split(/(\s+)/);
      const coords = { lng: parseFloat(geo[0]), lat: parseFloat(geo[2]) };
      console.log(coords);
      return coords;
    } else {
      return null;
    }
  };

  toggleTooltip = () => {
    this.setState(prevState => ({
      statusTooltipIsShown: !prevState.statusTooltipIsShown
    }));
  };

  saveWorkerChanges = workerData => {
    const { editJobWorker, worker, jobId } = this.props;
    editJobWorker(worker.id, workerData, jobId);
  };

  changeWorkerStatus = (newStatus, confirmationText) =>
    this.props.UIShowConfirm(
      confirmationText,
      () => this.saveWorkerChanges({ status: newStatus })
    );

  removeWorker = () => {
    this.changeWorkerStatus(jobWorkerStatus.REJECTED, confirmationMessages.removeWorker);
  };

  workerDidNotShow = () => {
    this.changeWorkerStatus(jobWorkerStatus.WORKER_NO_SHOW, confirmationMessages.workerNotShow);
  };

  workerCancelled = () => {
    this.changeWorkerStatus(jobWorkerStatus.WORKER_CANCELLED, confirmationMessages.workerCancelled);
  };

  workerCancelledConsequence = () => {
    this.changeWorkerStatus(jobWorkerStatus.WORKER_CANCELLED_CONSEQUENCE, confirmationMessages.workerCancelledConsequence);
  };


  hireWorker = () => {
    if (this.props.jobStatusIsFilled) {
      return this.props.UIShowAlert(alertMessages.jobIsFilled);
    }
    this.changeWorkerStatus(jobWorkerStatus.HIRED, confirmationMessages.hireWorker);
  };

  onQuickViewOpen = () => this.props.onQuickViewOpen(this.props.worker.user_id);
  onMapViewOpen = () => this.props.onMapViewOpen(this.props.worker.user_id);

  render () {
    const { worker, jobIsNotEditable, jobStartDate, jobEndDate, jobHasNotStarted, time_zone_id, UIShowAlert } = this.props;
    const { id, photo_image_url, status, checkin_at, checkout_at, payroll_date, approver_name, is_prior_confirmed,
      job_satisfaction_rating, job_satisfaction_comments, total_worker_pay, tip_amount, sent_home_reason,
      sent_home_comment, actual_hours, job_start_time, job_end_time, break_time, status_update_date,
      checkin_geolocation, checkout_geolocation } = worker;
    const workerStartTimeObj = job_start_time ? getDateWithOffset(job_start_time, time_zone_id) : job_start_time;
    const workerEndTimeObj = job_end_time ? getDateWithOffset(job_end_time, time_zone_id) : job_end_time;
    let workerBreakOptions = null;
    if (!_.isNull(break_time)) {
      workerBreakOptions = workerBreakMinutesValues.find(item => item.value === break_time * 60);
    }
    const checkIn = formatCheckInDate(checkin_at);
    const checkOut = formatCheckInDate(checkout_at);
    const first_name = worker.first_name || '';
    const last_name = worker.last_name || '';
    const fullName = first_name + ' ' + last_name;

    const ratingStars = [];
    if (job_satisfaction_rating) {
      for (let i = 0; i < job_satisfaction_rating; i++) {
        ratingStars.push(<FontAwesomeIcon key={i} icon={faStar} />);
      }
    }
    const workerIsHired = isWorkerHired(status);
    const workerIsOffered = isWorkerOffered(status);
    const isAdmin = UsersService.isAdmin();
    const workerPayIsShown = !!total_worker_pay && isAdmin;
    const sentHomeReasonIsOther = sent_home_reason === workerSentHomeReasons.other;
    const secondColumnIsInLayout = !!actual_hours || (!!payroll_date && isAdmin) || (!!total_worker_pay && isAdmin) || !!tip_amount || !!sent_home_reason;
    const canChangeWorkerHours = workerIsHired && !jobHasNotStarted;
    const canHireWorker = isAdmin && !workerIsHired;
    const canRemoveWorker = (workerIsHired && (jobHasNotStarted || UsersService.isAdmin())) || workerIsOffered;
    const canMakeWorkerDidNotShow = workerIsHired && !jobHasNotStarted;
    const hireButtonIsShown = !canChangeWorkerHours && canHireWorker;
    const removeButtonIsShown = !canChangeWorkerHours && !hireButtonIsShown && canRemoveWorker;
    const noShowButtonIsShown = !canChangeWorkerHours && !removeButtonIsShown && canMakeWorkerDidNotShow;
    const hireIsInMenu = !hireButtonIsShown && canHireWorker;
    const removeIsInMenu = !removeButtonIsShown && canRemoveWorker;
    const noShowIsInMenu = !noShowButtonIsShown && canMakeWorkerDidNotShow;
    const checkIn_coords = this.getCoords(checkin_geolocation) || '';
    const checkOut_coords = this.getCoords(checkout_geolocation) || '';
    return (
      <div className='table-row row job-worker-row-wrapper'>
        <div className='col-12 col-md-7 col-lg-4 worker-wrapper mb-3 mb-md-0'>
          <figure className='photo-wrapper mr-0 mr-md-3 mr-lg-4 mb-2 mb-md-0'>
            <button
              onClick={this.onQuickViewOpen}
              className='button-clean worker-photo'
              style={{ backgroundImage: `url('${photo_image_url || defaultUserPhoto}')` }}
            />
            <div id={`status-tooltip-target-${id}`} className={`status-label ${status}`}>
              { jobWorkerStatuses.find(status => status.id === worker.status).value }
            </div>
            <Tooltip
              placement='bottom'
              isOpen={this.state.statusTooltipIsShown}
              target={`status-tooltip-target-${id}`}
              toggle={this.toggleTooltip}
            >
              { renderDateWithTimeZone(status_update_date, uiDateFormat, time_zone_id)}
            </Tooltip>
          </figure>
          <div className='worker-info text-center text-md-left'>
            <h4>
              <button className='button-clean button-link' onClick={this.onQuickViewOpen}>{fullName}</button>
            </h4>
            { is_prior_confirmed && <p className='worker-info-row'>Confirmed to Work</p> }
            { checkin_at && <p className='worker-info-row'>Checked In: {checkIn}</p> }
            { checkout_at && <p className='worker-info-row'>Checked Out: {checkOut}</p> }

            { approver_name && <p className='worker-info-row'>Approver: {approver_name}</p> }
            { ratingStars.length > 0 && (
              <p className='worker-info-row'>
                Rating {` `}
                <span className='rating-stars-wrapper'>
                  { ratingStars.map(star => star)}
                </span>
              </p>
            )}
            { job_satisfaction_comments && (
              <p className='worker-info-row'>
                Comments: {job_satisfaction_comments}
              </p>
            )}
            { checkIn_coords && (
            <p className='worker-info-row'>
              <MapsPopup
                actual_hours={actual_hours}
                workerStartTime={workerStartTimeObj}
                workerEndTime={workerEndTimeObj}
                workerStartLocation={checkIn_coords || ''}
                workerEndLocation={checkOut_coords || ''}
                disableOnClickOutside
                UIShowAlert={UIShowAlert}
              />
            </p>
            )}
          </div>
        </div>
        { secondColumnIsInLayout && (
          <div className='col-12 col-md-5 col-lg-2 text-center text-md-left'>
            {!!actual_hours && (
              <JobWorkerTimeline {...worker} time_zone_id={time_zone_id} job_status={status} />
            )}
            { workerPayIsShown && (
              <p className='worker-info-row'>Final Payment: {formatPrice(getDollarPrice(total_worker_pay))}</p>
            )}
            { !!tip_amount && (
              <p className='worker-info-row'>
                { workerPayIsShown ? (
                  `(includes tip of ${formatPrice(getDollarPrice(tip_amount))})`
                ) : (
                  `Tip - ${formatPrice(getDollarPrice(tip_amount))}`
                )}
              </p>
            )}
            { !!sent_home_reason && (
              <React.Fragment>
                <p className='worker-info-row'>{ sentHomeReasonIsOther ? otherSentHomeReason : sent_home_reason }</p>
                { !!sent_home_comment && <p className='worker-info-row'>{ sent_home_comment }</p> }
              </React.Fragment>
            )}
          </div>
        )}
        { !jobIsNotEditable && (
          <div
            className={`col-12 col-lg-6
            d-flex flex-wrap worker-buttons justify-content-center justify-content-md-end align-items-center`}
          >
            { canChangeWorkerHours && (
              <HoursPopup
                actual_hours={actual_hours}
                jobStartDate={jobStartDate}
                jobEndDate={jobEndDate}
                workerStartTime={workerStartTimeObj}
                workerEndTime={workerEndTimeObj}
                workerBreakOptions={workerBreakOptions}
                saveWorkerChanges={this.saveWorkerChanges}
                disableOnClickOutside
                UIShowAlert={UIShowAlert}
              />
            )}
            { removeButtonIsShown && isAdmin && (
              <button
                className='button button-cancel'
                onClick={this.workerCancelled}
              >Worker Cancel</button>
            )}
            { removeButtonIsShown && isAdmin && (
            <button
              className='button button-delete'
              onClick={this.workerCancelledConsequence}
            >Worker Cancel &lt; 24hrs</button>
            )}
            { removeButtonIsShown && (
            <button
              className='button button-cancel'
              onClick={this.removeWorker}
            >Remove</button>
            )}
            { noShowButtonIsShown && (
              <button
                className='button button-cancel'
                onClick={this.workerDidNotShow}
              >Worker did not show</button>
            )}
            { hireButtonIsShown && (
              <button
                className='button button-primary ml-3'
                onClick={this.hireWorker}
              >Hire</button>
            )}
            { (hireIsInMenu || removeIsInMenu || noShowIsInMenu) && (
              <div className='worker-menu-wrapper'>
                <WorkerActionsMenu
                  removeWorker={this.removeWorker}
                  workerDidNotShow={this.workerDidNotShow}
                  hireWorker={this.hireWorker}
                  hireIsInMenu={hireIsInMenu}
                  removeIsInMenu={removeIsInMenu}
                  noShowIsInMenu={noShowIsInMenu}
                />
              </div>
            )}
          </div>
        )}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/app/jobDetails/WorkersTab/Worker.js